import React from 'react';
import { useLocation } from 'react-router-dom';
import PropertySuccessPage from '../components/hopphomes/PropertySuccessPage';
import BoostUpsellModal from '../components/hopphomes/BoostUpsellModal';

const PropertySuccess = () => {
  const location = useLocation();
  const { listingData, listingId } = location.state || {};
  const [showBoostModal, setShowBoostModal] = React.useState(false);

  const handleBoost = () => {
    setShowBoostModal(true);
  };

  const handleShare = (platform) => {
    console.log('Shared on:', platform);
    // Track analytics
  };

  const handleBoostSelect = (boostPlan) => {
    console.log('Boost selected:', boostPlan);
    setShowBoostModal(false);
    alert(`Boost aktiválva: ${boostPlan.title} - ${boostPlan.price} Ft`);
  };

  return (
    <>
      <PropertySuccessPage
        listingData={listingData}
        onBoost={handleBoost}
        onShare={handleShare}
      />

      <BoostUpsellModal
        isOpen={showBoostModal}
        onClose={() => setShowBoostModal(false)}
        onSelectBoost={handleBoostSelect}
        listingId={listingId}
      />
    </>
  );
};

export default PropertySuccess;
